module.exports = __webpack_public_path__ + "static/logo-a793d48682c630e5b0591c4dd5f089d5.png";